import type { DepartmentFragment } from "@/graphql";
import type { IMultiSelectItem, IOption } from "@/interfaces";
import type { InstitutionMinimal } from "@/extendedTypes.ts";

function institutionName(
  institutionId: string | undefined,
  institutions: InstitutionMinimal[] | null,
): string | null {
  if (institutions && institutionId) {
    const institution = institutions?.find((inst) => {
      return inst.id == institutionId;
    });
    if (institution) {
      return institution.name;
    }
  }

  return null;
}

const toMultiSelectItem = (
  item: DepartmentFragment,
  institutions: InstitutionMinimal[] | null = null,
): IMultiSelectItem => {
  return {
    id: item.id,
    title: [institutionName(item.institutionId, institutions), item.name]
      .filter((element) => {
        return element !== null && element !== undefined;
      })
      .join(" - "),
    icon: "fas fa-home",
    iconBackground: item.color || undefined,
  };
};

const toOption = (
  item: DepartmentFragment,
  institutions: InstitutionMinimal[] | null = null,
): IOption => {
  return {
    value: item.id,
    title: [institutionName(item.institutionId, institutions), item.name]
      .filter((element) => {
        return element !== null && element !== undefined;
      })
      .join(" - "),
  };
};

export default {
  toMultiSelectItem,
  toOption,
};
